<template>
  <div style="display: none;">
    <!-- 此组件仅用于设置 CSS 变量，不渲染任何内容 -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ThemeStyles',
  computed: {
    ...mapGetters(['domainConfig'])
  },
  watch: {
    domainConfig: {
      handler (newConfig) {
        this.setCssVariables(newConfig);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    setCssVariables (config) {
      // console.log(config);
      if (!config || typeof window === 'undefined') return;

      // 设置首页背景图变量
      if (config.homeBackground) {
        console.log(config.homeBackground.pc);
        document.documentElement.style.setProperty(
          '--home-bg-pc',
          `url('${config.homeBackground.pc}')`
        );
        document.documentElement.style.setProperty(
          '--home-bg-mobile',
          `url('${config.homeBackground.mobile}')`
        );
      }

      // 设置主题相关变量
      if (config.siteThemeColor) {
        // 添加主题class到html元素
        document.documentElement.classList.remove('theme-1', 'theme-2');
        document.documentElement.classList.add(`theme-${config.siteThemeColor}`);

        // 设置主题颜色变量
        const themeColors = {
          1: '#fe8400', // 橘色主题
          2: '#288862'  // 绿色主题
        };

        document.documentElement.style.setProperty(
          '--theme-color',
          themeColors[config.siteThemeColor] || themeColors[1]
        );
      }
    }
  }
}
</script> 